var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #cccccb;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n\n      .cls-2 {\n        stroke-linecap: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Class"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tableau"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.22,
    y: 1,
    width: 31.78,
    height: 4.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.69,
    y: 5.54,
    width: 26.83,
    height: 18.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 9.78,
    y1: 17.87,
    x2: 14.36,
    y2: 17.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 9.94,
    y1: 12.36,
    x2: 19.69,
    y2: 12.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1,
    y1: 24.51,
    x2: 33,
    y2: 24.51
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tirette"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 17.11,
    y1: 24.51,
    x2: 17.11,
    y2: 27.92
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 17.11,
    cy: 30.42,
    rx: 2.45,
    ry: 2.58
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClass);
export default __webpack_public_path__ + "static/media/Class.a00c9c9c3c3267978aab906dca7c4657.svg";
export { ForwardRef as ReactComponent };